import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

export class PusherHelper {
  setLogToConsole(value: boolean): void {
    Pusher.logToConsole = value;
  }

  getEchoInstance(options = {}): Echo {
    return new Echo(options);
  }
}

export default new PusherHelper();
